export const messages = {
  en: {
    userLogin: {
      search: {
        title: 'Search Conditions',
        name: 'Please enter staff name',
        tel: 'Please enter phone number',
        startTime: 'Login start time',
        endTime: 'Login end time'
      },
      table: {
        title: 'Login Logs',
        loginId: 'Login ID',
        parentOrgName: 'Company',
        orgName: 'Department',
        userName: 'Name',
        loginTime: 'Login Time',
        userId: 'Staff ID'
      },
      allStores: 'All',
      fetchError: 'Failed to fetch login logs',
      storeFetchError: 'Failed to fetch store list'
    }
  },
  zh: {
    userLogin: {
      search: {
        title: '查询条件',
        name: '请输入员工名称',
        tel: '请输入手机号',
        startTime: '登录开始时间',
        endTime: '登录结束时间'
      },
      table: {
        title: '登录日志',
        loginId: '登录ID',
        parentOrgName: '公司',
        orgName: '部门',
        userName: '名称',
        loginTime: '登录时间',
        userId: '员工ID'
      },
      allStores: '全部',
      fetchError: '获取登录日志失败',
      storeFetchError: '获取门店列表失败'
    }
  }
}